"use strict";

function postAll() {
  var r = this,
      e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];

  if (isValid(e)(["arraysArray", "postParamsArray", "stringsArray"])) {
    if (0 === e.length) return Promise.all(this.actions.map(function (e) {
      var n = e.message;
      return r.postMessage(n);
    }));
    if (e.every(function (r) {
      return "string" == typeof r;
    })) return Promise.all(e.map(function (e) {
      return r.postMessage(e);
    }));
    if (e.every(function (r) {
      return "object" === (void 0 === r ? "undefined" : _typeof(r)) && !Array.isArray(r);
    })) return Promise.all(e.map(function (e) {
      var n = e.message,
          t = e.args;
      return r.postMessage(n, t);
    }));
    if (e.every(function (r) {
      return Array.isArray(r);
    }) && e.length === this.actions.length) return Promise.all(e.map(function (e, n) {
      return r.postMessage(r.actions[n].message, e);
    }));
  }

  return console.error(argumentError(makeOptionsFor(e))), null;
}

var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
  return typeof r;
} : function (r) {
  return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
},
    isValidObjectWith = function isValidObjectWith(r) {
  return function (e) {
    return !!e && !Array.isArray(e) && r.every(function (r) {
      return e.hasOwnProperty(r);
    });
  };
},
    isValidAction = function isValidAction(r) {
  return isValidObjectWith(["message", "func"])(r) && "function" == typeof r.func && "string" == typeof r.message;
},
    isValidActionsArray = function isValidActionsArray(r) {
  return r.every(isValidAction);
},
    isValidPostParams = function isValidPostParams(r) {
  return isValidObjectWith(["message", "args"])(r) && Array.isArray(r.args) && "string" == typeof r.message;
},
    isValidPostParamsArray = function isValidPostParamsArray(r) {
  return r.every(isValidPostParams);
},
    isValidObjectsArray = function isValidObjectsArray(r) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return r.every(isValidObjectWith(e));
  };
},
    testArray = {
  actionsArray: function actionsArray(r) {
    return isValidActionsArray(r);
  },
  arraysArray: function arraysArray(r) {
    return r.every(function (r) {
      return Array.isArray(r);
    });
  },
  objectsArray: function objectsArray(r) {
    return isValidObjectsArray(r)();
  },
  postParamsArray: function postParamsArray(r) {
    return isValidPostParamsArray(r);
  },
  stringsArray: function stringsArray(r) {
    return r.every(function (r) {
      return "string" == typeof r;
    });
  }
},
    isValidArg = function isValidArg(r) {
  return function (e) {
    return "null" === e ? null === r : "undefined" === e ? void 0 === r : "action" === e ? isValidAction(r) : Array.isArray(r) ? !("array" !== e && !testArray[e]) && ("array" === e || testArray[e](r)) : !!r && (void 0 === r ? "undefined" : _typeof(r)) === e.toString();
  };
},
    isValid = function isValid(r) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return Array.isArray(e) ? e.some(function (e) {
      return isValidArg(r)(e);
    }) : !!isValidArg(r)(e);
  };
},
    argumentError = function argumentError(r) {
  var e = r.expected,
      n = void 0 === e ? "" : e,
      t = r.received,
      o = r.extraInfo,
      i = void 0 === o ? "" : o;

  try {
    return new TypeError("You should provide " + n + "\n" + i + "\nReceived: " + JSON.stringify(t));
  } catch (r) {
    if ("Converting circular structure to JSON" === r.message) return new TypeError("You should provide " + n + "\n" + i + "\nReceived a circular structure: " + t);
    throw r;
  }
},
    makeResponse = function makeResponse(r) {
  return "\n  self.onmessage = event => {\n    const args = event.data.message.args\n    if (args) {\n      self.postMessage((" + r + ").apply(null, args))\n      return close()\n    }\n    self.postMessage((" + r + ")())\n    return close()\n  }\n";
},
    createDisposableWorker = function createDisposableWorker(r) {
  var e = window.URL || window.webkitURL,
      n = new Blob([r], {
    type: "application/javascript"
  }),
      t = e.createObjectURL(n),
      o = new Worker(t);
  return o.post = function (r) {
    return new Promise(function (n, i) {
      o.onmessage = function (r) {
        e.revokeObjectURL(t), n(r.data);
      }, o.onerror = function (r) {
        console.error("Error: Line " + r.lineno + " in " + r.filename + ": " + r.message), i(r);
      }, o.postMessage({
        message: r
      });
    });
  }, o;
},
    run = function run() {
  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
      e = arguments[1],
      n = isValid(r)("function"),
      t = isValid(e)(["array", "undefined"]);

  if (n && t) {
    return createDisposableWorker(makeResponse(r)).post({
      args: e
    });
  }

  return n || console.error(argumentError({
    expected: "a function",
    received: r
  })), t || console.error(argumentError({
    expected: "an array",
    received: e
  })), null;
},
    warnWork = function warnWork(r) {
  return console.warn("WARN! " + r + " is not a registered action for this worker"), r + " is not a registered action for this worker";
},
    post = function post(r) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
        n = arguments[1],
        t = isValid(e)("string"),
        o = isValid(n)(["array", "undefined"]);

    if (t && o) {
      var i = r.filter(function (r) {
        var n = r.message;
        return JSON.stringify(n) === JSON.stringify(e);
      }).map(function (r) {
        return r.func;
      }).pop();
      return i ? n ? run(i, n) : run(i) : run(warnWork, [JSON.stringify(e)]);
    }

    return t || console.error(argumentError({
      expected: "a string",
      received: e
    })), o || console.error(argumentError({
      expected: "an array",
      received: n
    })), null;
  };
},
    makeOptionsFor = function makeOptionsFor(r) {
  return {
    expected: "an array of arrays, an array of objects, or an array of strings",
    received: r,
    extraInfo: "If an array of arrays, it must have the same length as the actions registered for this worker.\nIf an array of objects, every object must containing two fields:\n* message\n* args"
  };
},
    isActionOf = function isActionOf(r) {
  return function (e) {
    return r.some(function (r) {
      return r.message === e.message;
    });
  };
},
    warnMsg = function warnMsg(r) {
  return 'WARN! An action with message "' + r.message + '" is already registered for this worker';
},
    pushInto = function pushInto(r) {
  return function (e) {
    return isActionOf(r)(e) ? (console.warn(warnMsg(e)), r.length) : r.push(e);
  };
},
    makeOptionsFor$1 = function makeOptionsFor$1(r) {
  return {
    expected: "an array of actions or an action",
    received: r,
    extraInfo: "Every action should be an object containing two fields:\n* message\n* func"
  };
},
    register = function register(r) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return isValid(e)(["action", "actionsArray"]) ? Array.isArray(e) ? e.reduce(function (r, e) {
      return pushInto(r)(e), r;
    }, r).length : pushInto(r)(e) : (console.error(argumentError(makeOptionsFor$1(e))), null);
  };
},
    removeFrom = function removeFrom(r) {
  return function (e) {
    var n = r.findIndex(function (r) {
      return r.message === e;
    });
    return -1 === n ? console.warn('WARN! Impossible to unregister action with message "' + e + '".\nIt is not a registered action for this worker.') : r.splice(n, 1), r;
  };
},
    makeOptions = function makeOptions(r) {
  return {
    expected: "an array of strings or a string",
    received: r
  };
},
    unregister = function unregister(r) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return isValid(e)(["string", "stringsArray"]) ? Array.isArray(e) ? e.reduce(function (r, e) {
      return removeFrom(r)(e), r;
    }, r).length : removeFrom(r)(e).length : (console.error(argumentError(makeOptions(e))), null);
  };
},
    options = function options(r) {
  return {
    expected: "an array of objects",
    received: r,
    extraInfo: "Every action should be an object containing two fields:\n* message\n* func"
  };
},
    create = function create() {
  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return isValid(r)("actionsArray") ? {
    actions: r,
    postMessage: post(r),
    postAll: postAll,
    register: register(r),
    unregister: unregister(r)
  } : (console.error(argumentError(options(r))), null);
},
    createWrapper = function createWrapper() {
  return window.Worker ? window.URL.createObjectURL || window.webkitURL.createObjectURL ? {
    create: create,
    run: run
  } : (console.error("This browser does not have URL.createObjectURL method."), null) : (console.error("This browser does not support Workers."), null);
},
    WorkerWrapper = createWrapper();

module.exports = WorkerWrapper;